import {
  CTable,
  CTableBody,
  CTableDataCell,
  CTableHead,
  CTableHeaderCell,
  CTableRow,
} from "@coreui/react";
import { format } from "date-fns";
import qs from "qs";
import { useEffect, useState } from "react";
import { useQuery } from "react-query";
import { Link } from "react-router-dom";
import { useDebounce } from "usehooks-ts";
import Pagination from "../../components/ui/Pagination";
import RenderTable from "../../components/ui/RenderTable";
import { apiConfig } from "../../config/apiConfig";
import { Chip, Dash, removeEmptyFilterQueries } from "../../helpers/general";
import { useCookie } from "../../hooks/useCookie";
import { general } from "../../locales/general";
import apiService from "../../service/apiService";
import { cardStyle } from "../Places/PlacesTable";
import SearchBox from "../../components/ui/SearchBox";
import { tdStyle, thStyle } from "../../helpers/constants";

const PAGE_SIZE = 10;

export default function PartnerAccounts() {
  const { token } = useCookie("vToken");
  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const search = useDebounce(searchQuery, 500);

  useEffect(() => {
    setCurrentPage(1);
  }, [search]);

  const query = {
    _q: search,
    filters: { $and: [{ role: { label: { $eq: "Partner" } } }] },
    pagination: { limit: PAGE_SIZE, page: currentPage },
  };

  const endpoint = apiConfig.users.list(
    removeEmptyFilterQueries(qs.stringify(query, { encode: false })),
  );

  const { data, isLoading } = useQuery(
    ["getAllUsers", token, endpoint],
    () => apiService.MakeGetRequest(endpoint, token),
    { keepPreviousData: true },
  );

  const users: User[] = data?.items ?? [];

  return (
    <div>
      <div
        style={{ ...cardStyle, padding: "12px 16px" }}
        className="d-flex flex-wrap align-items-center gap-2 mb-3"
      >
        <SearchBox
          value={searchQuery}
          onChange={setSearchQuery}
          placeholder="Rechercher un compte"
        />
        {data?.meta?.totalItems !== undefined && (
          <Chip tone="warning">
            {data.meta.totalItems}{" "}
            {data.meta.totalItems > 1 ? "comptes" : "compte"}
          </Chip>
        )}
      </div>

      <div style={{ ...cardStyle, padding: 0, overflow: "hidden" }}>
        <RenderTable
          loading={isLoading}
          render={() =>
            users.length > 0 ? (
              <CTable responsive hover align="middle" className="mb-0">
                <CTableHead>
                  <CTableRow>
                    <CTableHeaderCell style={thStyle}>
                      Partenaire
                    </CTableHeaderCell>
                    <CTableHeaderCell style={thStyle}>
                      Téléphone
                    </CTableHeaderCell>
                    <CTableHeaderCell style={thStyle}>Ville</CTableHeaderCell>
                    <CTableHeaderCell style={thStyle}>Créé le</CTableHeaderCell>
                  </CTableRow>
                </CTableHead>
                <CTableBody>
                  {users.map((user) => (
                    <CTableRow key={user.id}>
                      <CTableDataCell style={tdStyle}>
                        <Link
                          to={`/users/${user.id}`}
                          className="fw-semibold text-capitalize d-block"
                        >
                          {user.fullName}
                        </Link>
                        <div className="text-muted" style={{ fontSize: 12 }}>
                          {user.email}
                        </div>
                      </CTableDataCell>
                      <CTableDataCell
                        style={{ ...tdStyle, whiteSpace: "nowrap" }}
                      >
                        {user.phone || <Dash />}
                      </CTableDataCell>
                      <CTableDataCell style={tdStyle}>
                        {user.city?.label ? (
                          <Chip>{user.city.label}</Chip>
                        ) : (
                          <Dash />
                        )}
                      </CTableDataCell>
                      <CTableDataCell
                        style={{ ...tdStyle, whiteSpace: "nowrap" }}
                      >
                        {format(new Date(user.createdAt), "dd/MM/yyyy")}
                      </CTableDataCell>
                    </CTableRow>
                  ))}
                </CTableBody>
              </CTable>
            ) : (
              <p className="text-center text-muted py-5 mb-0">
                {general.fr.noData}
              </p>
            )
          }
        />
      </div>

      <Pagination
        currentPage={currentPage}
        onPageChange={setCurrentPage}
        siblingCount={1}
        totalCount={data?.meta?.totalPages}
        pageSize={PAGE_SIZE}
      />
    </div>
  );
}
